export default [
    {
        label: 'Please select an option',
        value: '',
        disabled: true,
    },
    {
        label: 'It’s too expensive',
    },
    {
        label: 'I’m using a different provider',
    },
    {
        label: 'I have another product with MYOB',
    },
    {
        label: 'It’s too hard to use',
    },
    {
        label: 'I’m having too many technical issues',
    },
    {
        label: 'I’m no longer in business',
    },
    {
        label: 'Other (please explain in the comments)',
        value: 'other',
    },
];
